
import * as THREE from "../../libs/three.js/build/three.module.js";
import {Utils} from '../utils.js'
export class PolygonClipVolume extends THREE.Object3D{
	
	constructor(camera){
		super();

		this.constructor.counter = (this.constructor.counter === undefined) ? 0 : this.constructor.counter + 1;
		this.name = "polygon_clip_volume_" + this.constructor.counter;

		this.camera = camera.clone();
		this.camera.rotation.set(...camera.rotation.toArray()); // [r85] workaround because camera.clone() doesn't work on rotation
		this.camera.rotation.order = camera.rotation.order;
		this.camera.updateMatrixWorld();
		this.camera.updateProjectionMatrix();
		this.camera.matrixWorldInverse.copy(this.camera.matrixWorld).invert();

		this.viewMatrix = this.camera.matrixWorldInverse.clone();
		this.projMatrix = this.camera.projectionMatrix.clone();

		// projected markers
		this.markers = [];
		this.initialized = false;
		this.points = [];
		this.rays = [];
	}

	addMarker() {

		let marker = new THREE.Mesh();
		let point = new THREE.Vector3();
		let ray = new THREE.Ray()

		let cancel;

		let drag = e => {
			// let size = e.viewer.renderer.getSize(new THREE.Vector2());
			// let projectedPos = new THREE.Vector3(
			// 	2.0 * (e.drag.end.x / size.width) - 1.0,
			// 	-2.0 * (e.drag.end.y / size.height) + 1.0,
			// 	0
			// );

			// let I = Utils.getMousePointCloudIntersection(
			// 	e.drag.end,
			// 	e.viewer.scene.getActiveCamera(),
			// 	e.viewer,
			// 	e.viewer.scene.pointclouds);
				// console.log(I?.location)
			// if (I) {
			// 	point.copy(I.location);
			// 	//console.log(point)
			// 	//let i = this.spheres.indexOf(e.drag.object);
			// 	//if (i !== -1) {
			// 	//	this.setPosition(i, I.location);
			// 		//this.dispatchEvent({
			// 		//	'type': 'marker_moved',
			// 		//	'profile': this,
			// 		//	'index': i
			// 		//});
			// 	//}
			// }

			// let R = Utils.mouseToRay(
			// 	e.drag.end,
			// 	e.viewer.scene.getActiveCamera(),
			// 	size.width,
			// 	size.height
			// );

			//console.log("drag = ", R)
			// ray.copy(R);

			// marker.position.copy(projectedPos);
		};
		
		let drop = e => {
			let size = e.viewer.renderer.getSize(new THREE.Vector2());
			let projectedPos = new THREE.Vector3(
				2.0 * (e.drag.end.x / size.width) - 1.0,
				-2.0 * (e.drag.end.y / size.height) + 1.0,
				0
			);
			let P = Utils.getMousePlaneIntersection(
				e.drag.end,
				e.viewer.scene.getActiveCamera(),
				e.viewer,
				e.viewer.scene.pointclouds);
				console.log(P?.location)
			if (P) {
				point.copy(P.location);
			}

			let R = Utils.mouseToRay(
				e.drag.end,
				e.viewer.scene.getActiveCamera(),
				size.width,
				size.height
			);
			ray.copy(R);

			marker.position.copy(projectedPos);
			cancel();
		};
		
		cancel = e => {
			marker.removeEventListener("drag", drag);
			marker.removeEventListener("drop", drop);
		};
		
		marker.addEventListener("drag", drag);
		marker.addEventListener("drop", drop);

		this.points.push(point);
		this.rays.push(ray);
		this.markers.push(marker);
	}

	removeLastMarker() {
		if(this.markers.length > 0) {
			this.markers.splice(this.markers.length - 1, 1);
			this.points.pop();
			this.rays.pop();
		}
	}

	removeAllMarkers() {
		for (let i = 0; i < this.markers.length; i++) {
			this.removeLastMarker();
		}
	}

};